<template>

  <div class="gantt-container">

    <el-icon :size="16" color = "#606266" class="gantt-toolbar" @click="showEditDialog" >
      <ElIconEdit />
    </el-icon>

    <el-icon :size="16" color = "#606266" class="gantt-toolbar2" @click="this.dialogs.showAddSnapshot = true" >
      <ElIconCamera/>
    </el-icon>

    <IframeGantt class="gantt-div" ref="gantt" ></IframeGantt>

    <!-- 添加子任务 对话框 -->
    <el-dialog :title="'任务分解:' + currentDataName" v-model="dialogs.showEdit" :close-on-click-modal="false" width="900px" style="font-size: smaller" >
      <div style="overflow-x: auto;margin-top: -10px;font-size: smaller">
        <el-row style="background-color: whitesmoke;line-height: 30px;height: 30px;padding-top: 3px; border-bottom: 1px solid #e5e5e5">
          <el-col :span="5" style="text-align: left;padding-left: 3px">
            任务名称
          </el-col>
          <el-col v-if="actualMode==false" :span="3" style="text-align: center">
            计划开始日期
          </el-col>
          <el-col v-if="actualMode==false" :span="3" style="text-align: center">
            计划结束日期
          </el-col>
          <el-col v-if="actualMode==false" :span="3" style="text-align: center;padding-left: 3px">
            计划人天
          </el-col>

          <el-col v-if="actualMode==true" :span="3" style="text-align: center">
            实际开始日期
          </el-col>
          <el-col v-if="actualMode==true" :span="3" style="text-align: center">
            实际结束日期
          </el-col>
          <el-col v-if="actualMode==true"  :span="3" style="text-align: center">
            实际人天
          </el-col>

          <el-col :span="3" style="text-align: center">
            责任人
          </el-col>
          <el-col :span="3" style="text-align: center">
            进度(%)
          </el-col>
          <el-col :span="3" style="text-align: center">
            进度权重
          </el-col>

          <el-col :span="1" style="text-align: center;">
            <el-icon :size="16" @click="addTask()" >
              <ElIconPlus />
            </el-icon>
          </el-col>

        </el-row>

        <div style="overflow-y:auto ;height: 331px; min-height: 331px;margin-top: 5px;margin-bottom:10px; border: 1px solid #e5e5e5;font-size: smaller">
          <el-row v-for="item in subList" style="margin-bottom: 1px;font-size: smaller">
            <el-col :span="5" style="text-align: left">
              <el-input size="small" v-model="item.name" placeholder="任务名称" @change="autoCalculateWeight"></el-input>
            </el-col>
            <el-col v-if="actualMode==false" :span="3" style="text-align: center">
              <el-date-picker size="small" v-model="item.plan_start_date" placeholder="计划开始日期" style="width: 120px"  />
            </el-col>
            <el-col v-if="actualMode==false" :span="3" style="text-align: center">
              <el-date-picker size="small" v-model="item.plan_end_date" placeholder="计划结束日期" style="width: 120px" />
            </el-col>
            <el-col v-if="actualMode==false" :span="3" style="text-align: center">
              <el-input-number size="small" style="width:100%" v-model="item.plan_man_day" step="0.1" min="0" max="999" placeholder="计划人天" clearable></el-input-number>
            </el-col>

            <el-col v-if="actualMode==true" :span="3" style="text-align: center">
              <el-date-picker size="small" v-model="item.actual_start_date" placeholder="实际开始日期" style="width: 120px"  />
            </el-col>
            <el-col v-if="actualMode==true" :span="3" style="text-align: center">
              <el-date-picker size="small" v-model="item.actual_end_date" placeholder="实际结束日期" style="width: 120px" />
            </el-col>
            <el-col v-if="actualMode==true" :span="3" style="text-align: center">
              <el-input-number size="small" style="width:100%" v-model="item.actual_man_day" step="0.1" min="0" max="999" placeholder="实际人天" clearable></el-input-number>
            </el-col>

            <el-col :span="3" style="text-align: center">
              <el-select size="small" v-model="item.charge_user_id" clearable>
                <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-col>

            <el-col :span="3" style="text-align: center">
              <el-input-number  size="small" style="width:100%" v-model="item.progress_percent" step="1" min="0" max="100" clearable></el-input-number>
            </el-col>

            <el-col :span="3" style="text-align: center">
              <el-input-number  size="small" style="width:100%" v-model="item.progress_weight" step="1" min="0" max="100" clearable></el-input-number>
            </el-col>

            <el-col :span="1" style="text-align: center;">
              <el-icon :size="16" style="margin-top: 4px" @click="removeOneTask(item.id)">
                <ElIconClose />
              </el-icon>
            </el-col>

          </el-row>
        </div>
      </div>

      <el-row>
        <el-col :span="20" style="text-align: left">
          <el-button size="small" type="primary" @click="saveTasks">保存</el-button>
          <el-button size="small" v-if="actualMode==false" @click="actualMode=true">实际视图</el-button>
          <el-button size="small" v-if="actualMode==true" @click="actualMode=false">计划视图</el-button>
          <el-button size="small" @click="dialogs.showEdit = false">取消</el-button>
        </el-col>
      </el-row>

    </el-dialog>

    <!-- 创建快照 对话框 -->
    <el-dialog title="创建快照" v-model="dialogs.showAddSnapshot" :close-on-click-modal="false" width="450px" style="font-size: smaller" >
      <el-form v-model="snapshotData" label-width="110px">
        <el-form-item label="快照名称" required>
          <el-input v-model="snapshotData.name" placeholder="快照名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button size="small" type="primary" @click="addSnapshot">创建快照</el-button>
          <el-button size="small" @click="dialogs.showAddSnapshot = false">取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>



</template>

<script>
import IframeGantt from './IframeGantt.vue';
import {nanoid} from 'nanoid';

export default {
  name: 'ProjectTask',
  components: { IframeGantt },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      gantt_id: nanoid(),
      dateRange:{
        start_date: new Date(),
        end_date: new Date()
      },
      taskList:[],
      subList:[],
      userList:[],
      actualMode:false,
      currentData:{},
      currentDataName:'',
      currentId:'',
      snapshotData:{
        project_id: this.parentData.id,
        name:''
      },
      dialogs:{
        showEdit: false,
        showAddSnapshot: false,
      }
    }
  },
  methods: {

    async loadUsers() {
      this.userList = await this.$http('prjProjectService.getMemberAll', {project_id: this.parentData.id});
    },

    async loadData() {
      this.taskList = await this.$http('prjTaskService.getTasks', {project_id: this.parentData.id})
      let tasks = {"data": this.taskList, "links": []}

      this.$refs.gantt.refresh({}, tasks);
    },

    async saveTasks() {
      if(!this.currentId || this.currentId == ''){
        this.$message.error('不可在此编辑项目阶段，如需编辑请转到项目阶段菜单进行编辑')
        return;
      }
      if (this.subList.length > 0){
        this.subList.forEach((item) => {
          if (item.name && !item.progress_weight){
            this.$message.error('进度权重不能为空');
          }
        })
        // 校验进度权重总和是否为100
        const totalWeight = this.subList.reduce((sum, task) => sum + (task.progress_weight || 0), 0);
        if (totalWeight !== 100) {
          this.$message.error('进度权重总和必须为100，请检查后重新提交');
          return;
        }
      }
      await this.$http('prjTaskService.saveTasks', {project_id: this.parentData.id, parent_id: this.currentId, parent_level: this.currentData.task_level, stage_id: this.currentData.stage_id, tasks: this.subList})
      this.$message.success('保存成功')
      this.dialogs.showEdit = false
      this.loadData();
    },

    async addSnapshot() {
      if(!this.snapshotData.name || this.snapshotData.name == ''){
        return;
      }
      await this.$http('prjTaskSnapshotService.addSnapshot', this.snapshotData)
      this.$message.success('添加快照成功')
      this.dialogs.showAddSnapshot = false
    },

    addTask(){
      let task = {
        "id": 'new_' + nanoid(),
        "name": "新任务" + (this.subList.length + 1),
        "progress_percent": 0,
        "progress_weight": 0  // 确保新增任务有权重字段
      }
      this.subList.push(task)

      // 自动计算权重逻辑
      this.autoCalculateWeight()
    },

    removeOneTask(id) {
      console.log("removeOneTask, id=" + id)
      let index = this.subList.findIndex(item => item.id === id);
      console.log("index=" + index)
      this.subList.splice(index, 1);

      // 自动计算权重逻辑
      this.autoCalculateWeight()
    },

    // 自动计算权重逻辑
    async autoCalculateWeight() {
      // 调用权重分配逻辑
      const validTasks = this.subList.filter(task => task.name && task.name.trim() !== '');
      const total = validTasks.length;
      const average = Math.floor(100 / total);
      const remainder = 100 % total;

      this.subList.forEach((item, index) => {
        if (item.name && item.name.trim() !== '') {
          item.progress_weight = index < remainder ? average + 1 : average;
        } else {
          item.progress_weight = 0;
        }
      });
    },

    showEditDialog(){
      this.currentData = this.$refs.gantt.getSelectedData();
      console.log("currentData:" + this.currentData);
      this.currentId = this.currentData.id;
      this.currentDataName = this.currentData.name;

      this.subList = [];

      this.subList = this.taskList.filter(item => item.parent === this.currentId);
      console.log("subList:" + this.subList.length);

      this.dialogs.showEdit = true
    },

  },
  mounted: function () {
    this.loadUsers(),
    this.loadData();
  }
}
</script>

<style scoped>

.gantt-container {
  position: relative; /* 确保工具栏的定位是相对于这个容器 */
}

/* 工具栏样式 */
.gantt-toolbar {
  position: absolute;
  top:25px;
  left: 15px;
  padding: 0px;
  z-index: 999; /* 确保工具栏在甘特图上方 */
}

/* 工具栏样式 */
.gantt-toolbar2 {
  position: absolute;
  top:25px;
  left: 35px;
  z-index: 999; /* 确保工具栏在甘特图上方 */
}

.gantt-div {
  position: absolute;
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
}


</style>